import Autocomplete from "@mui/material/Autocomplete";
import TextField from "@mui/material/TextField";
import _ from "lodash";

function AffiliateSelector({ affiliates, onChange, selectedLocal }) {
  const sortedAffiliates = _.sortBy(affiliates, (item) => item.toLowerCase());
  return (
    <Autocomplete
      data-testid="affiliate-selector"
      disablePortal
      options={sortedAffiliates}
      sx={{ width: 300 }}
      renderInput={(params) => (
        <TextField
          {...params}
          label="Select a local"
          sx={{ backgroundColor: "white" }}
        />
      )}
      onChange={onChange}
      value={selectedLocal}
    />
  );
}

export default AffiliateSelector;
